// import { mapTagListFromFormValues } from 'containers/UploadForm/mappings';
import { isEmpty } from 'lodash';
import {
  ICategoryTagList,
  IConversionOptions,
  ITag,
  ITagCategoryID,
  ITagKeyValue,
  UploadFormFieldTypes
} from './types';

export const mapCategoryTagListContent = (tagList: ITag[], selectedTags: string[]) => {
  const category: ICategoryTagList = {};
  if (selectedTags && selectedTags.length > 0) {
    const tagSet: ITagKeyValue = {};
    tagList.forEach((tag: ITag) => {
      const name: string = tag.name.toLowerCase();
      tagSet[name] = tag;
    });

    selectedTags.forEach((tag: string) => {
      const tagDetails = tagSet[tag.toLowerCase()];
      if (tagDetails) {
        const categoryName = tagDetails.category ? tagDetails.category : 'Tags';
        if (category[categoryName]) {
          category[categoryName].push({ ...tagDetails });
        } else {
          category[categoryName] = [tagDetails];
        }
      }
    });
  }
  return category;
};

export const mapCTAConversion = (ctaData: any) => {
  if (ctaData) {
    const ctaContent: IConversionOptions = {
      id: ctaData.conversion,
      name: ctaData.name,
      icon: ctaData.icon,
      title: ctaData.title,
      form: ctaData.template.form,
      category: ctaData.template.category,
      type: ctaData.type,
      metadata: ctaData.metadata
    };
    return ctaContent;
  } else {
    return null;
  }
};

export const mapContentCreateData = (formData: UploadFormFieldTypes, marketerId: string) => {
  const contentData = {
    title: formData.title,
    description: formData.description,
    marketer: marketerId
  };

  const mediaUploadForm = new FormData();
  if (!isEmpty(formData.file)) {
    mediaUploadForm.append('files', formData.file);
  }

  const conversionCTA = !isEmpty(formData.cta)
    ? {
        conversion: formData.cta?.id,
        metadata: { url: formData.redirectURL, target: '_self' }
      }
    : null;

  interface newT {
    name: 'string';
    category: 'string';
  }
  const newTags: newT[] = [];
  Object.keys(formData.tags).forEach((category: string) => {
    if (category !== 'Tags') {
      const tags = formData.tags[category];
      tags.forEach((tag: string | ITag) => {
        if (typeof tag === 'string') {
          newTags.push({ name: tag as string, category: category } as newT);
        }
      });
    }
  });

  const allTags: string[] = Object.values(formData.tags)
    .flat()
    .map((obj: ITag | string) => (typeof obj === 'string' ? obj : obj.name));

  return {
    contentData,
    mediaUploadForm,
    conversionCTA,
    newTags,
    allTags
  };
};

export const mapContenUpdateData = (
  formData: UploadFormFieldTypes,
  previousData: UploadFormFieldTypes,
  previousConversion: IConversionOptions,
  previousTags: ICategoryTagList
) => {
  let contentData = null;
  if (formData.title !== previousData.title || formData.description !== previousData.description) {
    contentData = { title: formData.title, description: formData.description };
  }

  let conversionCTA = null;
  let removeConversionCTA = null;

  if (
    formData.cta &&
    (formData.cta.id !== previousConversion?.id ||
      (formData.cta.type === 'REDIRECT' && formData.redirectURL !== previousConversion?.metadata?.url))
  ) {
    conversionCTA = {
      conversion: formData.cta.id,
      metadata: { url: formData.redirectURL, target: '_self' }
    };
  } else {
    if (formData.cta === null && previousConversion?.id) {
      removeConversionCTA = true;
    }
  }

  const newTagCategoryMapper: ITagCategoryID = {};

  const newTaglist: string[] = [];
  const newTagCreatedCategory: ITagCategoryID = {};
  Object.keys(formData.tags).forEach((categoryId: string) => {
    formData.tags[categoryId].forEach((tag: ITag | string) => {
      if (typeof tag === 'string') {
        newTagCategoryMapper[tag] = categoryId;
        if (categoryId !== 'Tags') {
          newTagCreatedCategory[tag] = categoryId;
        }
        newTaglist.push(tag);
      } else {
        newTagCategoryMapper[tag.name] = categoryId;
        newTaglist.push(tag.name);
      }
    });
  });

  const previousTagCategoryMapper: ITagCategoryID = {};
  Object.keys(previousTags).forEach((categoryId: string) => {
    previousTags[categoryId].forEach((tag: ITag | string) => {
      previousTagCategoryMapper[(tag as ITag).name] = categoryId;
    });
  });

  let newTagCreated = false;
  let isTagRemoved = false;
  Object.keys(previousTagCategoryMapper).forEach(tag => {
    if (!newTagCategoryMapper[tag]) {
      isTagRemoved = true;
    }
  });

  Object.keys(newTagCategoryMapper).forEach(tag => {
    if (!previousTagCategoryMapper[tag]) {
      newTagCreated = true;
    }
  });

  let mediaUploadForm = null;
  if (previousData.status !== 'Approved' && formData.file instanceof File) {
    mediaUploadForm = new FormData();
    mediaUploadForm.append('files', formData.file);
  }

  return {
    contentData,
    conversionCTA,
    newTagCreatedCategory:
      newTagCreatedCategory && Object.keys(newTagCreatedCategory).length > 0 ? newTagCreatedCategory : null,
    newTaglist: newTagCreated || isTagRemoved ? newTaglist : null,
    mediaUploadForm: mediaUploadForm,
    removeConversionCTA
  };
};

// export const mapUploadFormContent = (data: UploadFormFieldTypes, marketerId: string) => {
//   const { title, description, tags, tagsUpdated , cta, redirectURL } = data;

//   const categoryTagRelation = tags
//     .map(category => {
//       if (category.id && category.id !== 'tags' && category.value && category.value.length > 0) {
//         return category.value.map(tag => {
//           if (tag.value) {
//             return { category: category.id, tag: tag.value };
//           } else {
//             return { category: category.id, tagLabel: tag };
//           }
//         });
//       }
//       return false;
//     })
//     .flat()
//     .filter((item: any) => item !== false);

//   const newTags = { tags: mapTagListFromFormValues(tags) };

//   return {
//     data: {
//       title,
//       description,
//       tags: mapTagListFromFormValues(tags),
//       marketer: marketerId
//     },
//     conversionToCTA: {
//       conversion: cta.value,
//       metadata: {
//         url: redirectURL,
//         target: '_self'
//       }
//     },
//     categoryTagRelation,
//     newTags
//   };
// };

export const mapUploadMediaFile = (data: UploadFormFieldTypes) => {
  const { file } = data;
  const formData = new FormData();
  if (!isEmpty(file)) {
    formData.append('files', file);
  }
  return formData;
};

// export const mapUpdateUpload = (data: UploadFormFieldTypes) => {
//   const { title, description, tags, cta, redirectURL } = data;
//   const info = { title, description };
//   const newTags = { tags: tags.map(item => item.tag).flat() };
//   return {
//     info,
//     newTags,
//     conversionToCTA: {
//       conversion: cta.value,
//       metadata: {
//         url: redirectURL,
//         target: '_self'
//       }
//     }
//   };
// };
